var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChats = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19644"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19642"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M18.084 2.5H6.377A3.877 3.877 0 0 0 2.5 6.377v8.19a3.877 3.877 0 0 0 3.877 3.877h2.91l2.061 2.52a1.14 1.14 0 0 0 1.765 0l2.061-2.52h2.91a3.877 3.877 0 0 0 3.877-3.877v-8.19A3.877 3.877 0 0 0 18.084 2.5Z",
  "data-name": "Path 27311"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 7670"
})))));
export { SvgChats as ReactComponent };
export default __webpack_public_path__ + "static/media/chats.9f17907bb7f284d4b7f67d95e6c40bd2.svg";